import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M6 16h12M6 19h8m0-12.5a2 2 0 11-4 0 2 2 0 014 0zM5.75 22h12.5a2 2 0 002-2V4a2 2 0 00-2-2H5.75a2 2 0 00-2 2v16a2 2 0 002 2z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M6 16h12M6 19h8m0-12.5a2 2 0 11-4 0 2 2 0 014 0zM5.75 22h12.5a2 2 0 002-2V4a2 2 0 00-2-2H5.75a2 2 0 00-2 2v16a2 2 0 002 2z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 28v-1a5 5 0 015-5h8a5 5 0 015 5v1m-21 4h24m-24 6h16m0-25a4 4 0 11-8 0 4 4 0 018 0zM11.5 44h25a4 4 0 004-4V8a4 4 0 00-4-4h-25a4 4 0 00-4 4v32a4 4 0 004 4z"
  }))
};
export var NikeMembership = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});